<template>
  <div class="mv-h-full d-flex flex-column justify-center">
    <span class="text-h2 font-weight-semibold white--text">Image Creator</span>
    <span class="text-h5 grey--text text--darken-1 mt-3">Created with AI</span>
    <v-form ref="form" class="input-form-area mt-5">
      <span class="white--text">{{
        $t("gallary.ui.input_form_keywords_label")
      }}</span>
      <v-text-field
        v-model="keywords"
        dark
        :counter="20"
        :placeholder="$t('gallary.ui.input_form_keywords_placeholder')"
        dense
        filled
        outlined
        :rules="[validators.required]"
      ></v-text-field>
      <span class="white--text mt-5">{{
        $t("gallary.ui.input_form_category_label")
      }}</span>
      <v-select
        v-model="category"
        :items="categoryItems"
        :placeholder="$t('gallary.ui.input_form_category_placeholder')"
        dark
        dense
        filled
        outlined
        :no-data-text="$t('gallary.ui.input_form_category_placeholder')"
      >
      </v-select>
      <span class="white--text mt-5">{{
        $t("gallary.ui.input_form_style_label")
      }}</span>
      <v-select
        v-model="style"
        :items="styleItems"
        :placeholder="$t('gallary.ui.input_form_style_placeholder')"
        dark
        dense
        filled
        outlined
        :no-data-text="$t('gallary.ui.input_form_style_nodata_text')"
      >
      </v-select>
      <span class="white--text mt-5">{{
        $t("gallary.ui.input_form_bg_color_label")
      }}</span>
      <v-select
        v-model="backgroundColor"
        :items="backgroundColorItems"
        :placeholder="$t('gallary.ui.input_form_bg_color_Placeholder')"
        dark
        dense
        filled
        outlined
        :no-data-text="$t('gallary.ui.input_form_bg_color_Placeholder')"
      >
      </v-select>
      <div class="mt-5 text-center">
        <v-btn
          width="50%"
          color="primary"
          rounded
          dark
          :loading="generating"
          :disabled="generating"
          @click="onGenerate"
          >{{ $t("gallary.ui.input_form_button_generate") }}</v-btn
        >
      </div>
    </v-form>
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
import { get } from "vuex-pathify";
import { required } from "@/utils/validation.js";

// Pubsub
import { gallaryIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";

// image
import { az_genereate_iconUrl } from "@/pptjs/api/api_azure_openai.js";

//例如: import <组件名称> from  <组建路径>

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      keywords: "",
      category: "",
      categoryItems: [],
      style: "",
      styleItems: [],
      backgroundColor: "",

      generating: false,

      validators: {
        required,
      },
    };
  },
  //计算机属性 类似与data概念
  computed: {
    ...get("gallary", ["categories", "backgroundColorItems"]),
  },
  //监控data中数据变化
  watch: {
    category(val) {
      for (let i = 0; i < this.categories.length; i++) {
        let category = this.categories[i];
        if (category.name == val) {
          this.styleItems = category.styleItems;
          break;
        }
      }
    },
  },
  methods: {
    onGenerate() {
      let validate = this.$refs.form.validate();
      if (validate) {
        let params = {
          inputText: this.keywords,
        };
        var that = this;
        this.generating = true;
        az_genereate_iconUrl(params).then((res) => {
          that.generating = false;
          publish(gallaryIds.pubId_Local_Image_Generated, res.data.result);
        },
        (err) => {
          console.error(err);
          that.generating = false;
        });
      }
    },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {
    this.categoryItems = this.categories.map((item) => item.name);
  },
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {},
  destroyed() {}, //生命周期-销毁完成
  activated() {}, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss"></style>
